import type { CSSProperties } from 'react';
import { LineChart, Line, BarChart, Bar, ResponsiveContainer } from 'recharts';
import type { ColumnDef } from '@deckspace/types';

interface SparklineViewProps {
  nodeId: string;
  mapping: { value: string };
  type?: 'line' | 'bar';
  color?: string;
  className?: string;
  style?: CSSProperties;
  // Injected by withDataset HOC (Task 8):
  rows: Record<string, unknown>[];
  columnDefs?: ColumnDef[];
}

export function SparklineView({
  mapping,
  type = 'line',
  color = '#3b82f6',
  className,
  style,
  rows,
}: SparklineViewProps) {
  return (
    <div className={className} style={style}>
      <div className="h-8 w-24">
        <ResponsiveContainer width="100%" height="100%">
          {type === 'bar' ? (
            <BarChart data={rows ?? []}>
              <Bar dataKey={mapping.value} fill={color} radius={[1, 1, 0, 0]} />
            </BarChart>
          ) : (
            <LineChart data={rows ?? []}>
              <Line
                type="monotone"
                dataKey={mapping.value}
                stroke={color}
                dot={false}
                strokeWidth={1.5}
              />
            </LineChart>
          )}
        </ResponsiveContainer>
      </div>
    </div>
  );
}
